import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./public.css";
import App from "../public/App.tsx";
import { ThemeProvider } from "../shared/context";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </StrictMode>
);
